var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "upload-box-mini" }, [
    _c("div", { staticClass: "loading" }, [
      this.creatorStudio.settings.similiarImageJob.apiJob?.status.code !=
      "completed"
        ? _c("img", { attrs: { src: _vm.loadingImage } })
        : _vm._e(),
    ]),
    _vm._v(" "),
    this.creatorStudio.settings.similiarImageJob.base64 !== null &&
    _vm.loading === false
      ? _c(
          "div",
          { staticClass: "removePreview", on: { click: _vm.removeImage } },
          [_c("i", { staticClass: "far fa-trash-alt" }), _vm._v(" Remove")]
        )
      : _vm._e(),
    _vm._v(" "),
    this.creatorStudio.settings.similiarImageJob.base64 !== null
      ? _c("img", {
          attrs: { src: this.creatorStudio.settings.similiarImageJob.base64 },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }